import classNames from 'classnames';
import { DateTime } from 'luxon';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { formatCurrencyGB } from 'helpers/formatNumber';
import Button from '../Button';
import FlexContainer from '../FlexContainer';
import SupportBlock from '../SupportBlock';
import Txt from '../Txt';
import styles from './UserPaymentView.module.scss';

/**
 * UserPaymentView
 *
 * @return {JSX.Element}
 */
const UserPaymentView = ({ className, item, onClose }) => {
  const handleDismiss = () => onClose();
  const dateReceived = DateTime.fromJSDate(fromSwiftDate(item.dateCreated));

  return (
    <FlexContainer
      className={classNames(
        styles.UserPaymentView,
        className,
        UserPaymentView.displayName
      )}
      column
      gap
    >
      <FlexContainer spaceBetween alignCenter>
        <Txt xxx>Payment received from:</Txt>
        <FlexContainer column alignEnd>
          <Txt regular>
            {dateReceived.toLocaleString(DateTime.TIME_WITH_SECONDS)}
          </Txt>
          <Txt regular>{dateReceived.toLocaleString(DateTime.DATE_FULL)}</Txt>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer spaceBetween alignCenter>
        <Txt xxx>{item.paymentFromName}</Txt>
        <Txt xxxx>{formatCurrencyGB(item.amountPaid)}</Txt>
      </FlexContainer>
      <FlexContainer column gapHalf>
        <Txt>Faster payments</Txt>
        <Txt>
          Payments arrive to your bank account immediately but in rare case can
          take up to two hours to arrive.
        </Txt>
      </FlexContainer>
      <Button success onClick={handleDismiss}>
        Dismiss
      </Button>
      <SupportBlock />
    </FlexContainer>
  );
};

UserPaymentView.displayName = 'UserPaymentView';

export default UserPaymentView;
